/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPropertyCrimeDetail
 */
export interface ExecRiskPropertyCrimeDetail {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPropertyCrimeDetail
     */
    burglary_index?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPropertyCrimeDetail
     */
    larceny_index?: number;
}

/**
 * Check if a given object implements the ExecRiskPropertyCrimeDetail interface.
 */
export function instanceOfExecRiskPropertyCrimeDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskPropertyCrimeDetailFromJSON(json: any): ExecRiskPropertyCrimeDetail {
    return ExecRiskPropertyCrimeDetailFromJSONTyped(json, false);
}

export function ExecRiskPropertyCrimeDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPropertyCrimeDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'burglary_index': !exists(json, 'burglary_index') ? undefined : json['burglary_index'],
        'larceny_index': !exists(json, 'larceny_index') ? undefined : json['larceny_index'],
    };
}

export function ExecRiskPropertyCrimeDetailToJSON(value?: ExecRiskPropertyCrimeDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'burglary_index': value.burglary_index,
        'larceny_index': value.larceny_index,
    };
}

